<template>
  <v-container fluid class="pa-0">
    <v-row class="my-0 py-0">
      <v-col class="my-1 py-1" cols="12" md="4">
        <v-text-field
          class="rounded-lg"
          label="Nombre de la plaza*"
          outlined
          dense
          v-model="nombrePlaza"
          :readonly="true"
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.salario })">
        <v-text-field
          class="rounded-lg calculator-icon-bold"
          label="Honorarios*"
          outlined
          dense
          v-model="salario"
          @focus="handleSalarioFocus"
          append-icon="mdi-calculator"
          @click:append="isView && !editableEnFaseP15F3 ? null : handleCalculatorClick()"
          :readonly="isView && !editableEnFaseP15F3"
          :disabled="desahabilitarAccionCalculo"
          @keypress="restrictToNumbersAndDot"
          @blur="isView && !editableEnFaseP15F3 ? null : handleCalculatorClick()"
          :error-messages="getErrorMessages('salario')"
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.totalSalarioMensual })">
        <v-text-field
          class="rounded-lg"
          label="Total honorarios mensual por plaza*"
          outlined
          :readonly="true"
          dense
          :value="formatCurrency(aportaciones.totalHonorariosMensual)"
        />
      </v-col>
    </v-row>
    <v-row class="my-0 py-0">
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.costoPlaza })">
        <v-text-field
          class="rounded-lg"
          label="Costo por plaza*"
          outlined
          :readonly="true"
          dense
          :value="formatCurrency(aportaciones.costoPlaza)"
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.plazas })">
        <v-text-field
          class="rounded-lg"
          label="Plazas*"
          outlined
          :readonly="true"
          dense
          :value="aportaciones.plazas"
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.costoTotalPlazas })">
        <v-text-field
          class="rounded-lg"
          label="Costo total plazas*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.costoTotalPlazas)"
          dense
        />
      </v-col>
    </v-row>
    <v-row class="my-0 py-0">
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.isr })">
        <v-text-field
          class="rounded-lg"
          label="Impuesto Sobre la Renta (ISR)*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.isr)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.totalIsr })">
        <v-text-field
          class="rounded-lg"
          label="Total ISR*"
          outlined
          :readonly="true"
          :value="formatCurrency(aportaciones.totalIsr)"
          dense
        />
      </v-col>
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.salarioMinimo })">
        <v-text-field
          class="rounded-lg"
          label="Salario mínimo*"
          outlined
          :readonly="!rangoSalarialEditable"
          v-model="salarioMinimoLocal"
          @keypress="restrictRangeToNumbersAndDot($event, salarioMinimoLocal)"
          @input="actualizarValorRango('salarioMinimo', $event)"
          :error-messages="salarioMinimoErrors"
          dense
        />
      </v-col>
    </v-row>
    <v-row class="my-0 py-0">
      <v-col class="my-1 py-1" cols="12" md="4" v-role="validRoleFunction({ ver: roles.salarioMaximo })">
        <v-text-field
          class="rounded-lg"
          label="Salario máximo*"
          outlined
          :readonly="!rangoSalarialEditable"
          v-model="salarioMaximoLocal"
          @keypress="restrictRangeToNumbersAndDot($event, salarioMaximoLocal)"
          @input="actualizarValorRango('salarioMaximo', $event)"
          :error-messages="salarioMaximoErrors"
          dense
        />
      </v-col>
    </v-row>
    <v-row class="my-0 py-0 d-flex justify-center justify-sm-start">
      <v-col class="my-1 py-1" cols="12" md="auto" v-role="validRoleFunction({ ver: roles.verCuadro })">
        <v-btn
          class="lowercase-text px-5"
          outlined
          color="primary"
          style="color: #fff; text-transform: none !important"
          rounded
          @click="verCuadroAportaciones"
        >
          Ver cuadro de aportaciones
        </v-btn>
      </v-col>
      <v-col v-if="mostrarBotonBitacora" cols="12" md="auto" class="d-flex align-center justify-end px-4" align-self="start">
        <v-btn color="#e5e7eb" elevation="0" rounded class="text-none grayTextCalm" @click="openBitacora">
          Bitácora
        </v-btn>
      </v-col>
    </v-row>
    <BitacoraModal
      v-model="showBitacora"
      :items="bitacoraItems"
      :esServiciosProfesionales="true"
      :id-tipo-solicitud="solicitud?.id_tipo_solicitud ?? solicitud?.tipo_solicitud?.id"
    />
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex/dist/vuex.common.js';
import BitacoraModal from "@/views/solicitudes/components/BitacoraModal.vue";
import solicitudServices from "@/services/solicitud.services.js";

export default {
  name: "CuadroAportacionesServiciosProfesionales",
  components: { BitacoraModal },
  props: {
    faseActivaUsuario: {
      type: Boolean,
      default: false
    },
    fase: {
      type: String,
      default: ""
    },
    nombrePlaza: {
      type: String,
      default: ""
    },
    isView: {
      type: Boolean,
      default: false
    },
    aportaciones: {
      type: Object,
      default: () => ({})
    },
    salarioMinimo: {
      type: Number,
      required: false,
      default: null
    },
    salarioMaximo: {
      type: Number,
      required: false,
      default: null
    },
    rangoSalarialEditable: {
      type: Boolean,
      default: false
    },
    validRoleFunction: {
      type: Function,
      default: () => ({ action: "show" })
    },
    roles: {
      type: Object,
      default: () => ({
        nombrePlaza: "",
        salario: "",
        totalSalarioMensual: "",
        costoPlaza: "",
        plazas: "",
        costoTotalPlazas: "",
        isr: "",
        totalIsr: "",
        salarioMinimo: "",
        salarioMaximo: "",
        verCuadro: ""
      })
    },
    errorValidation: {
      type: Boolean,
      default: false
    },
    mostrarBotonBitacora: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      salario: "",
      lastSalarioEmitted: "",
      salarioMinimoLocal: "",
      salarioMaximoLocal: "",
      showBitacora: false,
      bitacoraItems: []
    };
  },
  computed: {
    ...mapState({
      solicitud: state => state.solicitud.solicitud
    }),
    editableEnFaseP15F3() {
      return this.fase === "P15-F3" && this.rangoSalarialEditable && this.rangoSalarialValido;
    },
    desahabilitarAccionCalculo() {
      const esSedeCentral = [true, 1, "1", "true"].includes(this.solicitud?.sede_central);
      const esAdscrita = [true, 1, "1", "true"].includes(this.solicitud?.es_adscrita);
      if (!esSedeCentral || (esAdscrita && this.fase !== "P15-F3")) return true;

      const cumpleFase = ["P15-F4", "P15-F5"].includes(this.fase);
      const perfilSoloLectura = ['Jefe RRHH', 'Director', 'Jefe UFI'].includes(this.solicitud?.perfil);

      if (this.fase === "P15-F3" && !this.rangoSalarialValido) return true;

      if(this.fase == "P15-F3" && perfilSoloLectura && !this.solicitud?.fase_activa_usuario) return true;
      if(cumpleFase && perfilSoloLectura && !this.solicitud?.fase_activa_usuario) return true;
      return cumpleFase && perfilSoloLectura;
    },
    salarioMinimoNumerico() {
      return this.parseMonto(this.salarioMinimoLocal);
    },
    salarioMaximoNumerico() {
      return this.parseMonto(this.salarioMaximoLocal);
    },
    rangoSalarialValido() {
      return this.salarioMinimoNumerico > 0
        && this.salarioMaximoNumerico > 0
        && this.salarioMinimoNumerico <= this.salarioMaximoNumerico;
    },
    salarioMinimoErrors() {
      if (!this.rangoSalarialEditable) return [];
      if (!(this.salarioMinimoNumerico > 0)) return ["Ingrese un salario mínimo mayor a 0"];
      if (this.salarioMaximoNumerico > 0 && this.salarioMinimoNumerico > this.salarioMaximoNumerico) {
        return ["El salario mínimo no puede ser mayor que el salario máximo"];
      }
      return [];
    },
    salarioMaximoErrors() {
      if (!this.rangoSalarialEditable) return [];
      if (!(this.salarioMaximoNumerico > 0)) return ["Ingrese un salario máximo mayor a 0"];
      if (this.salarioMinimoNumerico > 0 && this.salarioMinimoNumerico > this.salarioMaximoNumerico) {
        return ["El salario máximo debe ser mayor o igual al salario mínimo"];
      }
      return [];
    }
  },
  watch: {
    "aportaciones.honorario": {
      handler(newVal) {
        const currentClean = String(this.salario || '').replace(/[^0-9.]/g, '');
        const currentNum = parseFloat(currentClean);
        const newNum = parseFloat(newVal);

        if (newVal !== undefined && newVal !== null && newVal !== "" && newNum !== currentNum) {
          this.salario = this.formatCurrency(newNum);
        }

        this.lastSalarioEmitted = newVal != null ? String(newVal) : "";
      },
      immediate: true
    },
    salarioMinimo: {
      handler(value) {
        this.salarioMinimoLocal = this.formatearRangoRecibido(value);
      },
      immediate: true
    },
    salarioMaximo: {
      handler(value) {
        this.salarioMaximoLocal = this.formatearRangoRecibido(value);
      },
      immediate: true
    },
    rangoSalarialEditable() {
      this.salarioMinimoLocal = this.formatearRangoRecibido(this.salarioMinimo);
      this.salarioMaximoLocal = this.formatearRangoRecibido(this.salarioMaximo);
    }
  },
  methods: {
    formatearRangoRecibido(value) {
      if (value === null || value === undefined || value === "") return "";
      return this.rangoSalarialEditable ? String(value) : this.formatCurrency(value);
    },
    parseMonto(value) {
      const cleanValue = String(value ?? "").replace(/[^0-9.]/g, "");
      if (!cleanValue) return null;
      const parsed = Number(cleanValue);
      return Number.isFinite(parsed) ? parsed : null;
    },
    normalizarMonto(value) {
      const cleanValue = String(value ?? "").replace(/[^0-9.]/g, "");
      const [entero = "", ...decimales] = cleanValue.split(".");
      if (decimales.length === 0) return entero;
      return `${entero}.${decimales.join("").slice(0, 2)}`;
    },
    restrictRangeToNumbersAndDot(event, value) {
      const char = event.key;
      const currentValue = String(value ?? "").replace(/[^0-9.]/g, "");
      if (!/[0-9.]/.test(char)) {
        event.preventDefault();
        return;
      }
      if (char === "." && currentValue.includes(".")) {
        event.preventDefault();
        return;
      }
      const decimals = currentValue.split(".")[1];
      if (currentValue.includes(".") && char !== "." && decimals?.length >= 2) {
        event.preventDefault();
      }
    },
    actualizarValorRango(campo, value) {
      const valueNormalizado = this.normalizarMonto(value);
      if (campo === "salarioMinimo") this.salarioMinimoLocal = valueNormalizado;
      if (campo === "salarioMaximo") this.salarioMaximoLocal = valueNormalizado;
      this.lastSalarioEmitted = "";
      this.$emit("actualizarRangoSalarial", {
        salarioMinimo: this.salarioMinimoNumerico,
        salarioMaximo: this.salarioMaximoNumerico
      });
    },
    getErrorMessages(field) {
      if (!this.errorValidation) return [];

      const value = this.aportaciones[field];

      if (value === null || value === undefined || value === 0 || value === "") {
        return ["Digite el salario para el cálculo"];
      }

      return [];
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '';
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(numValue)) return '';
      return `$${numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    },
    handleSalarioFocus() {
      const cleanValue = String(this.salario).replace(/[^0-9.]/g, '');
      if (cleanValue !== this.salario) {
        this.salario = cleanValue;
      }
    },
    restrictToNumbersAndDot(event) {
      const char = event.key;
      const value = String(this.salario || '');

      if (!/[0-9.]/.test(char)) {
        event.preventDefault();
        return;
      }

      if (char === '.' && value.includes('.')) {
        event.preventDefault();
        return;
      }

      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length >= 2) {
          event.preventDefault();
        }
      }
    },
    handleCalculatorClick() {
      this.calcularValores();
    },
    calcularValores() {
      if (this.fase === "P15-F3" && !this.rangoSalarialValido) {
        this.temporalAlert({
          show: true,
          message: "Ingrese un salario mínimo y máximo válidos antes de calcular las aportaciones",
          type: "warning"
        });
        return;
      }

      const cleanValue = String(this.salario).replace(/[^0-9.]/g, '');
      const salarioValue = parseFloat(cleanValue);

      if (isNaN(salarioValue) || !cleanValue) {
        this.temporalAlert({
          show: true,
          message: "Debe ingresar un salario válido",
          type: "warning"
        });
        return;
      }

      const tieneMinimo = this.salarioMinimoNumerico > 0;
      const tieneMaximo = this.salarioMaximoNumerico > 0;

      if (tieneMinimo && salarioValue < this.salarioMinimoNumerico) {
        this.temporalAlert({
          show: true,
          message: `El salario no puede ser menor que el salario mínimo ${this.formatCurrency(this.salarioMinimoNumerico)}`,
          type: "warning"
        });
        return;
      }

      if (tieneMaximo && salarioValue > this.salarioMaximoNumerico) {
        this.temporalAlert({
          show: true,
          message: `El salario no puede ser mayor que el salario máximo ${this.formatCurrency(this.salarioMaximoNumerico)}`,
          type: "warning"
        });
        return;
      }

      if (cleanValue !== this.lastSalarioEmitted) {
        this.$emit("calcularAportaciones", cleanValue, false);
        this.lastSalarioEmitted = cleanValue;
      }

      this.salario = '';
      this.$nextTick(() => {
        this.salario = this.formatCurrency(salarioValue);
      });
    },
    verCuadroAportaciones() {
      this.$emit("verCuadroAportaciones");
    },
    mapCuadroAportacionesBitacora(cuadro = {}) {
      return {
        nombrePlaza: cuadro.nombrePlaza ?? "",
        salarioMinimo: cuadro.salarioMinimo ?? null,
        salarioMaximo: cuadro.salarioMaximo ?? null,
        aportaciones: {
          honorario: cuadro.honorario ?? null,
          totalHonorariosMensual: cuadro.totalHonorariosMensual ?? null,
          costoPlaza: cuadro.costoPlaza ?? null,
          plazas: cuadro.plazas ?? null,
          costoTotalPlazas: cuadro.costoTotalPlazas ?? null,
          isr: cuadro.isr ?? null,
          totalIsr: cuadro.totalIsr ?? cuadro.totalPlazaISR ?? null
        }
      };
    },
    mapBitacoraResponse(rawItems = []) {
      return rawItems.map((item, index) => {
        const fechaCruda = item.fecha_modificacion || item.created_at;
        const fechaFormateada = fechaCruda
          ? this.moment(fechaCruda).format("DD/MM/YYYY hh:mm A")
          : "";
        return {
          _uid: item._id ?? index,
          nombres: item.nombre_modificador ?? "",
          cargo: item.cargo ?? "",
          fecha: fechaFormateada,
          comparacion_inicial: this.mapCuadroAportacionesBitacora(
            item.modificaciones?.cuadro_aportaciones_anterior
          ),
          comparacion_final: this.mapCuadroAportacionesBitacora(
            item.modificaciones?.cuadro_aportaciones_nuevo
          )
        };
      });
    },
    async openBitacora() {
      const idSolicitud = this.solicitud?.id;
      if (!idSolicitud) return;
      try {
        this.setLoader(true);
        const response = await solicitudServices.getBitacoraCuadroAportaciones(idSolicitud);
        if (response?.status === 200) {
          const items = response.data?.data ?? response.data ?? [];
          const rawItems = Array.isArray(items) ? items : [];
          this.bitacoraItems = this.mapBitacoraResponse(rawItems);
          this.showBitacora = true;
        }
      } catch (error) {
        this.temporalAlert({
          show: true,
          message: error?.message || "Error al obtener la bitácora",
          type: "error"
        });
      } finally {
        this.setLoader(false);
      }
    },
    ...mapMutations("utils", ["setLoader"])
  }
};
</script>

<style scoped>
.calculator-icon-bold:not(.v-input--is-disabled) ::v-deep .v-input__append-inner .v-icon {
  font-weight: 900 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

.grayTextCalm {
  color: #6c7280;
}
</style>
